import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight, Route } from "lucide-react";
import Seo from "@/components/common/Seo";
import { OurJourney } from "@/components/sections/OurJourney";

export default function OurJourneyPage() {
  return (
    <div className="bg-[var(--acx-bg)]">
      <Seo
        title="Our Journey"
        description="The AutoCareX journey — key milestones from our 2019 foundation to OEM-scale private labelling and the launch of AutoCareX into omnichannel retail."
      />

      {/* Page header — compact intro; the timeline section below carries the main heading */}
      <section className="relative acx-noise overflow-hidden">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(800px_circle_at_25%_0%,rgba(156,163,175,0.10),transparent_55%),radial-gradient(640px_circle_at_85%_10%,rgba(225,27,34,0.10),transparent_55%)]" />
        <div className="acx-container relative px-4 pt-10 pb-6 sm:px-6 lg:px-10 lg:pt-14 lg:pb-8">
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <nav className="flex items-center gap-2 text-[13px] text-white/45" aria-label="Breadcrumb">
              <Link to="/" className="transition-colors hover:text-white">Home</Link>
              <ChevronRight size={14} />
              <Link to="/about" className="transition-colors hover:text-white">About</Link>
              <ChevronRight size={14} />
              <span className="text-white/70">Our Journey</span>
            </nav>
            <span className="mt-5 inline-flex items-center gap-2 rounded-full border border-[color:var(--acx-border)] bg-white/5 px-3.5 py-1.5 text-[12px] uppercase tracking-[0.18em] text-white/55">
              <Route size={14} className="text-[#E11B22]" /> Our Story
            </span>
          </motion.div>
        </div>
      </section>

      {/* Reused homepage section (carries the "Our Journey" heading + timeline) */}
      <OurJourney compact />
    </div>
  );
}
